<style></style>

<app-demo-banner></app-demo-banner>
<main class="main">
  <app-cdt-navbar></app-cdt-navbar>
  @if (!demo) {
    <app-anomaly-banners></app-anomaly-banners>
    <app-announcement-banners></app-announcement-banners>
  }
  <router-outlet />
</main>
<app-tour-panel></app-tour-panel>
